import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";


import { AuthService } from "@/revamp/firebase/config";
import i18n from "./i18n";
require("@/revamp/assets/main.scss");

// FontAwesome global setup
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faKey, faEye, faEyeSlash, faSignature, faEarth, faCircleCheck, faCircle } from '@fortawesome/free-solid-svg-icons';
library.add(faEnvelope, faKey, faEye, faEyeSlash, faSignature, faEarth, faCircleCheck, faCircle);

import datadogLoggingServiceInstance from "@/revamp/utils/datadogLoggingService";
import useFeatureFlags from "@/revamp/composables/useFlags";

const vuetify = createVuetify({
  components,
  directives,
});

let app;

AuthService.onAuthStateChanged(async () => {
  // i18n, render: h => h(App),
  if (!app) {
    // app.use(i18n);
    await useFeatureFlags.initialize();

    // const router = createAppRouter();

    datadogLoggingServiceInstance.logInfo('Datadog initialized in main.js');
    app = createApp(App);
    app.component('FontAwesomeIcon', FontAwesomeIcon);
    app.use(i18n);
    app.use(router);
    app.use(vuetify);
    app.mount("#app");
  }
});
